import { Textarea, makeStyles, tokens, TextareaProps } from '@fluentui/react-components';
import { FC } from 'react';

const useStyles = makeStyles({
    syTextarea: {
        width: '100%',
        borderRadius: '0.5rem',
        background: tokens.colorNeutralBackground1,
        border: `1px solid ${tokens.colorNeutralStroke2}`,
        boxShadow: 'none !important',
        '& .fui-Textarea__textarea': {
            boxShadow: 'none !important',
            '::placeholder': {
                color: tokens.colorNeutralForeground3,
            },
        },
        '&:focus-within': {
            outline: '2px solid var(--color-primary-400) !important',
            outlineOffset: '2px !important',
            border: `1px solid ${tokens.colorNeutralStroke2} !important`,
            boxShadow: 'none !important',
            background: `${tokens.colorNeutralBackground1} !important`,
        },
        '&::after': {
            display: 'none !important',
            content: 'none !important',
            borderBottom: 'none !important',
        },
        '& .fui-Textarea__textarea:focus::after': {
            display: 'none !important',
            content: 'none !important',
            borderBottom: 'none !important',
        },
        '& .fui-Textarea__textarea:focus + div::after': {
            display: 'none !important',
        },
        '&:focus-within::after': {
            display: 'none !important',
            content: 'none !important',
            borderBottom: 'none !important',
        },
    },
});

export const SyTextarea: FC<TextareaProps> = (props) => {
    const classes = useStyles();
    
    return (
        <Textarea
            {...props}
            className={`${classes.syTextarea} ${props.className || ''}`}
        />
    );
};
